import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
// import { getMe } from "./auth";
// import CryptoJS from "crypto-js";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _urlPrefix = "/company-transaction";


export const fetchCompanyTransactionListPaging = createAsyncThunk(
  "company-transaction/fetchCompanyTransactionListPaging",
  async (params) => {
      const result = await httpRequest({
          url: `${_urlPrefix}`,
          method: "GET",
          params: AppUtil.toSnakeCaseKey(params)
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);



const initialState = {
  list: []
};

const companyTransaction = createSlice({
  name: "companyTransaction",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchCompanyTransactionListPaging.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload && payload.content) {
        state.list = payload.content;
      }
      return state;
    }
  }
});

const { reducer } = companyTransaction;

export default reducer;

export const getCompanyTransactionListPaging = createSelector(
  (state) => state.companyUser.list,
  (list) => list
);